// 全局filter定义在这里
import Vue from 'vue';

/**
 * 日期格式化，传入毫秒格式化
 */
Vue.filter('dateFormat', formatDate);

/**
 * 日期格式化，传入秒格式化
 */
Vue.filter('dateFormatS', (val, format) => {
    return formatDate(val * 1000, format);
});

function formatDate(val, format) {
    let deFormat;
    let theDate;
    let month;
    let year;
    let date;
    let hours;
    let mins;
    let seconds;
    let formats = {
        LLLL: function() {
            return `${year}年${month}月${date}日  ${hours}:${mins}`;
        },
        LLL: function() {
            return `${year}年${month}月${date}日`;
        },
        llll: function() {
            return `${year}.${month}.${date}  ${hours}:${mins}`;
        },
        lll: function() {
            return `${year}.${month}.${date}`;
        },
        LL: function() {
            return `${month}月${date}日`;
        },
        mm: function() {
            return `${hours}:${mins}`;
        },
        Lll: function() {
            return `${year}-${month}-${date}`;
        },
        Ll: function() {
            return `${year}-${month}`;
        },
        Llls: function() {
            return `${year}/${month}/${date}`;
        },
        Lllss: function() {
            return `${year}/${month}/${date} ${hours}:${mins}:${seconds}`;
        },
        Lllmm: function() {
            return `${year}-${month}-${date}  ${hours}:${mins}`;
        },
        hhmm: function() {
            return `${hours}:${mins}`;
        }
    };
    if (!val && typeof val !== 'number') {
        return '';
    }
    deFormat = format || 'LLL';
    theDate = new Date(parseInt(val));
    year = theDate.getFullYear();
    month = padStart(String(theDate.getMonth() + 1), 2, '0');
    date = padStart(String(theDate.getDate()), 2, '0');
    hours = padStart(String(theDate.getHours()), 2, '0');
    mins = padStart(String(theDate.getMinutes()), 2, '0');
    seconds = padStart(String(theDate.getSeconds()), 2, '0');
    return formats[deFormat]();
}

function padStart(sourceString, targetLength, padString = ' ') {
    padString = typeof padString === 'string' ? padString : String(padString);
    targetLength = targetLength >> 0;
    if (sourceString.length > targetLength) {
        return sourceString;
    } else {
        targetLength = targetLength - sourceString.length;
        if (targetLength > padString.length) {
            padString += stringRepeat(padString, targetLength / padString.length);
        }
        return padString.slice(0, targetLength) + sourceString;
    }
}
